import ArrowDownIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import ArrowUpIcon from "@mui/icons-material/KeyboardArrowUpRounded";
import { Box, Paper, Stack, Typography } from "@mui/material";
import type { PropsWithChildren } from "react";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";

interface Props {
  title: string;
  subtitle?: string;
  expanded?: boolean;
  onToggleExpanded?: () => void;
}

const EntitySectionHeader = ({ title, subtitle, expanded, onToggleExpanded, children }: PropsWithChildren<Props>) => {
  const collapsible = expanded !== undefined && onToggleExpanded !== undefined;

  const handleClick = () => {
    if (collapsible) {
      onToggleExpanded();
    }
  };

  return (
    <Paper
      sx={{
        position: "sticky",
        top: 0,
        px: 2.5,
        border: 1,
        borderColor: "divider",
        borderRadius: "4px 4px 0 0",
        borderLeft: 0,
        borderRight: 0,
        zIndex: 100,
      }}
      elevation={0}
    >
      <Box
        onClick={handleClick}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "4rem",
          cursor: collapsible ? "pointer" : undefined,
        }}
      >
        <Stack spacing={0.5} sx={{ minWidth: 0 }}>
          <Typography variant="h6">{title}</Typography>
          {subtitle && (
            <TypographyTooltipEllipsis
              text={subtitle}
              observeContainerResize
              typographyProps={{ variant: "caption", color: "textSecondary" }}
            />
          )}
        </Stack>
        <Stack spacing={1} direction="row" sx={{ alignItems: "center" }}>
          {collapsible && expanded && <ArrowUpIcon />}
          {collapsible && !expanded && <ArrowDownIcon />}
          {children}
        </Stack>
      </Box>
    </Paper>
  );
};

export default EntitySectionHeader;
